import { ForwardTradeChangeRequestModalMode } from "@/app/components/forward-trade-change-request-modal";
import {
  AcceptTradeContractChangeRequestMutationHookResult,
  ChangeRequestAction,
  ChangeRequestStatus,
  RejectTradeContractChangeRequestMutationHookResult,
  TradeContractChangeRequest,
  WithdrawTradeContractChangeRequestMutationHookResult,
} from "@/app/types/generated/graphql";

type AddNewRequestButtonProps = {
  showAddNewRequestButton?: boolean;
  onClickAddNewRequest?: () => void;
  viewOnly?: boolean;
};

export type UseRequestDateChangeTableProps = {
  tradeContractId: string;
  refetchTradeContract?: () => Promise<void>;
};

export type UpdateChangeRequestProps = {
  paymentDate: TradeContractChangeRequest["paymentDate"];
  deliveryDate: TradeContractChangeRequest["deliveryDate"];
  mode: ForwardTradeChangeRequestModalMode;
};

export type RequestDateChangeTableProps = AddNewRequestButtonProps & UseRequestDateChangeTableProps;

export type RequestDateChangeTableViewProps = AddNewRequestButtonProps & {
  loading: boolean;
  tableData: TradeContractChangeRequest[];
  reloadChangeRequestHistory: () => void;
  allowAddingNewRequest: boolean;
  hideActionColumn: boolean;
  actions: {
    onChangeRequestAction: (changeRequest: TradeContractChangeRequest, currentAction: ChangeRequestAction) => void;
    onUpdateOrCounter: (args: UpdateChangeRequestProps) => void;
  };
};

export type ChangeRequestActionMutationMap = Partial<
  Record<
    ChangeRequestAction,
    | AcceptTradeContractChangeRequestMutationHookResult[0]
    | WithdrawTradeContractChangeRequestMutationHookResult[0]
    | RejectTradeContractChangeRequestMutationHookResult[0]
  >
>;

export const changeRequestHistoryChipVariant = {
  [ChangeRequestStatus.Accepted]: "chips.primary",
  [ChangeRequestStatus.Invalidated]: "chips.error",
  [ChangeRequestStatus.Open]: "chips.info",
  [ChangeRequestStatus.Countered]: "chips.info",
  [ChangeRequestStatus.Rejected]: "chips.error",
  [ChangeRequestStatus.Withdrawn]: "chips.info",
  [ChangeRequestStatus.Pending]: "chips.info",
};

export const ChangeRequestModalContent: Partial<
  Record<
    ChangeRequestAction,
    {
      title: string;
      subtitle: string;
      successMessage: string;
      errorMessage: string;
    }
  >
> = {
  [ChangeRequestAction.Accept]: {
    title: "Are you sure you want to accept this change request?",
    subtitle:
      "Accepting this change request will update the payment and delivery dates to the under mentioned values. Please confirm to proceed.",
    successMessage: "Change request accepted successfully",
    errorMessage: "Failed to accept change request",
  },
  [ChangeRequestAction.Reject]: {
    title: "Are you sure you want to reject this change request?",
    subtitle:
      "Rejecting this change request will decline the requested changes to the payment and delivery dates mentioned below. Please confirm to proceed.",
    successMessage: "Change request rejected successfully",
    errorMessage: "Failed to reject change request",
  },
  [ChangeRequestAction.Withdraw]: {
    title: "Are you sure you want to withdraw this change request?",
    subtitle:
      "Withdrawing this change request will cancel the requested changes to the payment and delivery dates mentioned below. Please confirm to proceed.",
    successMessage: "Change request withdrawn successfully",
    errorMessage: "Failed to withdraw change request",
  },
};
